import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faTimes} from "@fortawesome/free-solid-svg-icons";
import {INVOICE_NUMBER_PART_TYPES, INVOICE_NUMBER_DATE_FORMATS, invoiceNumberTemplateLabel} from "../../utils/workflow-invoice-number";

/** Edit invoice-number tokens inline; insert/remove controls preserve their saved order. */
export default function InvoiceNumberTemplate({value, onChange, data}) {
    const parts = value?.parts || [];
    const read = key => data.t.read(key);
    const variables = parts.filter(part => part.type !== "text");
    const separators = [];
    let variableIndex = -1;
    for (const part of parts) {
        if (part.type !== "text") {
            variableIndex += 1;
            if (variableIndex < variables.length - 1) separators[variableIndex] = "";
        } else if (variableIndex >= 0 && variableIndex < variables.length - 1) {
            separators[variableIndex] += part.text || "";
        }
    }
    // Keep the existing API format: separators are literal parts internally.
    // Empty separators need no part, so the API's non-empty literal contract stays intact.
    const save = (nextVariables, nextSeparators) => onChange({parts: nextVariables.flatMap((part, index) =>
        index < nextVariables.length - 1 && nextSeparators[index]
            ? [part, {type: "text", text: nextSeparators[index]}] : [part])});
    const update = (index, part) => save(variables.map((p, i) => i === index ? part : p), separators);
    const changeType = (index, type) => update(index, {type, ...(type.endsWith("_date") ? {format: variables[index].format || "YYYYMMDD"} : {})});
    const remove = index => save(variables.filter((_, i) => i !== index), separators.filter((_, i) => i !== Math.min(index, separators.length - 1)));
    return <div className="invoice-number-template">
        <div className="invoice-number-template__builder">
            <div className="invoice-number-template__tokens">
                {variables.map((part, index) => <React.Fragment key={index}>
                    {index > 0 && <input maxLength={100} className="invoice-number-template__separator"
                        aria-label={`${read("rule.number_separator")} ${index}`} value={separators[index - 1] || ""}
                        onChange={e => save(variables, separators.map((separator, i) => i === index - 1 ? e.target.value : separator))} />}
                    <div className="invoice-number-template__token">
                        <select className="invoice-number-template__name" aria-label={`${read("rule.number_variable_type")} ${index + 1}`} value={part.type}
                            onChange={e => changeType(index, e.target.value)}>
                            {INVOICE_NUMBER_PART_TYPES.filter(type => type !== "text").map(type => <option key={type} value={type}>{read(`rule.number_${type}`)}</option>)}
                        </select>
                        {part.type.endsWith("_date") && <select className="invoice-number-template__format" aria-label={`${read("rule.number_date_format")} ${index + 1}`} value={part.format}
                            onChange={e => update(index, {...part, format: e.target.value})}>
                            {INVOICE_NUMBER_DATE_FORMATS.map(format => <option key={format}>{format}</option>)}
                        </select>}
                        <button type="button" className="invoice-number-template__remove" aria-label={`${read("rule.number_remove")} ${index + 1}`}
                            onClick={() => remove(index)}><FontAwesomeIcon icon={faTimes} /></button>
                    </div>
                </React.Fragment>)}
            </div>
            <div className="invoice-number-template__insert">
                <button type="button" className="btn btn-outline-primary btn-sm" disabled={variables.length >= 10}
                    onClick={() => save([...variables, {type: "submission_date", format: "YYYYMMDD"}], [...separators, "_"])}><FontAwesomeIcon icon={faPlus} className="mr-2" />{read("rule.number_insert_variable")}</button>
            </div>
        </div>
        <div className="small mt-2 text-muted"><span>{read("rule.number_example")}: </span><output className="text-dark">{invoiceNumberTemplateLabel(value, read, true)}</output></div>
    </div>;
}
